import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { LocationSearchComponent } from "../components/DeliveryLocation/Search/LocationSearchComponent";

const redirectToLocationHome = (item: SimpleLocation) => {
  document.location.href =
    "/HospitalGiftShop.aspx?hm=1&hid=" + item.ID.toString();
};

const setupLocationComponent = () => {
  const searchRoot = document.getElementById("location-search") as HTMLElement;

  if (searchRoot) {
    const root = ReactDOM.createRoot(searchRoot);

    root.render(
      <React.StrictMode>
        <LocationSearchComponent handleSelect={redirectToLocationHome} />
      </React.StrictMode>,
    );
  }
};

setupLocationComponent();
